export default function () {
  (function ($) {
    
    $(document).on("gform_confirmation_loaded", function (event, formID) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "formSubmission",
            formID: formID
        });
    });
    
  })(jQuery);
};